import type {ReactElement} from 'react';
import {useIsSmallerThanBreakpointWidth} from '@Hooks/useIsSmallerThanBreakpoint';
import {ScreenBreakpoints} from '@Libraries/responsiveness-library';
import styles from './ai-text-prompt-box-loading.module.scss';

interface AiTextsPromptBoxLoadingProps {
  isShown: boolean;
  message: string;
  invertedColors?: boolean;
  containerClasses?: string;
  hiddenEllipsis?: boolean;
}

export function AiTextPromptBoxLoading({...props}: AiTextsPromptBoxLoadingProps): ReactElement<any> | null {
  if (!props.isShown) {
    return null;
  }

  const isModal = useIsSmallerThanBreakpointWidth(ScreenBreakpoints.MOBILE_MODAL_ACTIVATION_BREAKPONT);

  return (
    <div className={`${props.containerClasses} `}>
      <div
        className={`
          flex-row-align-center _fit-width 
          ${styles.aiTextsLoading}  
          ${props.hiddenEllipsis ? styles.hiddenEllipsis : ''}
          ${props.invertedColors ? `${styles.invertedColors} spacing-p-0` : ''}
        `}
      >
        <div className={`${styles.aiTextsLoadingText} ${isModal ? 'body-lg-regular' : 'body-md-regular'}`}>{props.message}</div>
      </div>
    </div>
  );
}
